import { useState } from "react";
import { Card, Form } from "react-bootstrap";
import ErrorComponent from "../../../Components/ErrorMessage";
import './dateselection.css'
import { replacePlaceholder } from "../../../Utils/Utils";
function DateQuestion({ question, handleChange, formValues, showError }) {
  const isMandatory = question.isMandatory;
  const questionText = replacePlaceholder(question.questionText, formValues);

  // Get current value from formValues
  const currentValue = formValues[question.tempId] || "";
  const hasAnswer = currentValue !== "";

  const handleInputChange = (event) => {
    const value = event.target.value;
    handleChange({
      target: { 
        name: question.tempId, 
        value: value,
        type: "date" 
      },
    });
  };

  return (
    <Card className={`mt-3 ${isMandatory && showError && !hasAnswer ? "border-danger" : ""}`}>
      <Card.Body>
        <Form.Group controlId={question.tempId}>
          <div className="d-flex flex-column">
            <Form.Label>
              <b className="preserve-text">
                {question.tempId}.{questionText}
                {isMandatory && <span className="text-danger">*</span>}
              </b>
            </Form.Label>
            <Form.Label>
              <b style={{ color: 'lightblue' }}>{question.questionDescription}</b>
            </Form.Label>
            {isMandatory && showError && !hasAnswer && (
              <ErrorComponent message={question.requiredErrorText} />
            )}
          </div>
          <Form.Control
            type="date"
            name={question.tempId}
            id={question.tempId}
            value={currentValue}
            onChange={handleInputChange}
            className="form-control date-input"
          />
        </Form.Group>
      </Card.Body>
    </Card>
  );
}

export default DateQuestion;
